<div class="roles-table__container">
  <table #rolesTableEl mat-table [dataSource]="dataSource" class="roles-table" [trackBy]="trackByFn">
    <!-- Permission Name Column -->
    <ng-container matColumnDef="permission" sticky>
      <th mat-header-cell *matHeaderCellDef>Options</th>
      <td mat-cell *matCellDef="let row">
        <div [ngClass]="{'permission-child': row.isChild}">
          <div class="permission-name">
            @if (row.isChild) {
              <span class="permission-name__dot">•</span>
            }
            {{ row.name }}
          </div>
          @if (!row.isChild) {
            <div class="permission-desc">{{ row.description }}</div>
          }
        </div>
      </td>
    </ng-container>

    <!-- Dynamic Role Columns -->
    @for (role of displayedColumns.slice(1); track role) {
      <ng-container [matColumnDef]="role">
        <th mat-header-cell *matHeaderCellDef>
          <div
            class="roles-table__role-actions"
            [ngClass]="{'roles-table__role-actions--show-menu': !(role | getRoleFromMap: allRolesMap())?.isSystemRole}"
          >
            <span [title]="role"> {{ role }}</span>
            @if (!(role | getRoleFromMap: allRolesMap())?.isSystemRole) {
              <list-view-menu [options]="menuOptions" (action)="onMenu($any($event), role)" />
            }
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="permission-toggle-container">
            <oph-slide-toggle
              class="permission-slide-toggle"
              [disabled]="
                (role | getRoleFromMap: allRolesMap())?.isSystemRole ||
                isLoading() ||
                (row | isChildDisabled: role : dataSource)
              "
              [checked]="row.roles[role]?.active"
              (toggle)="togglePermission(role, row, $event)"
            />
          </div>
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngStyle]="{height: row.isChild ? '46px' : '68px'}"
    ></tr>
    <tr *matNoDataRow>
      <td class="roles-table__empty" [attr.colspan]="displayedColumns.length">No permissions found.</td>
    </tr>
  </table>
</div>
